module.exports = __webpack_public_path__ + "img/forbid-up-btn.918d72f4.svg";